import { render, staticRenderFns } from "./InvoiceTop.vue?vue&type=template&id=5df3e43b&scoped=true"
import script from "./InvoiceTop.vue?vue&type=script&lang=js"
export * from "./InvoiceTop.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTop.vue?vue&type=style&index=0&id=5df3e43b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df3e43b",
  null
  
)

export default component.exports